import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, id) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`formulario/completo/${id}`),
      ]);
      return data;
    },
    async enviar(_, payload) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('formularioresposta/all', payload),
      ]);
      return data;
    },
    async formularioIdentificado(_, { id, cpf }) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`formularioidentificacao/${id}/${cpf}`),
      ]);
      return data;
    },

    async update(_, payload) {
      const [{ data }] = await Promise.all([
        apiempresaweb.put('formularioresposta/update/all', payload),
      ]);
      return data;
    },

    async updateById(_, { id }) {
      const [{ data }] = await Promise.all([
        apiempresaweb.put(`formulario/concluir/${id}`),
      ]);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
